"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Authed = Authed;
exports.closeButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
var _common = require("./common.js");
/* eslint-disable complexity */

const closeButton = exports.closeButton = "pl-cufyn01";
/**
 * Authed Account Tray component.
 *
 * @param {Object} props React props
 * @param {string} props.customerNumberLabel customer number label
 * @param {string} props.customerUsernameLabel customer username label
 * @param {string} props.pinLabel pin label
 * @param {string} props.viewPinLabel view pin label
 * @param {string} props.signOutLabel sign out label
 * @param {string} props.rewardPointsLabel reward points label
 * @param {string} props.callLabel call label
 * @param {string} props.emailLabel email label
 * @param {string} props.ssoUrl sso url
 * @param {string} props.accountUrl account url
 * @param {string} props.accountProductsUrl account products url
 * @param {object} props.menus Menus
 * @param {object} props.customerRes True means authenticated. False unauthenticated.
 * @param {object} props.infoResponse Info response
 * @param {function} props.displayName Display Name
 * @returns {React.ReactElement} Authed Account tray
 * @public
 */
function Authed({
  customerNumberLabel,
  customerUsernameLabel,
  pinLabel,
  viewPinLabel,
  rewardPointsLabel,
  vipAccountExecLabel,
  callLabel,
  emailLabel,
  signOutLabel,
  ssoUrl,
  accountUrl,
  accountProductsUrl,
  closeTray,
  accountTrayRef,
  menus,
  displayName,
  customerRes,
  infoResponse
}) {
  const vip = customerRes?.vip;
  const isPro = customerRes?.proshopper?.pro;
  const customerNameUrl = accountProductsUrl ?? `${accountUrl}/products?go_redirect=disabled`;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "authed-account-tray"
  }, /*#__PURE__*/_react.default.createElement(_common.Caret, null), /*#__PURE__*/_react.default.createElement(_common.Flyout, {
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => closeTray(accountTrayRef),
    className: closeButton
  }), /*#__PURE__*/_react.default.createElement(_common.AccountInfoContainer, null, /*#__PURE__*/_react.default.createElement(_common.CustomerName, (0, _extends2.default)({
    href: customerNameUrl
  }, _patternLibraryUtils.tracking.create('manage_your_account_link', true, false)), displayName), /*#__PURE__*/_react.default.createElement("div", null, customerNumberLabel && /*#__PURE__*/_react.default.createElement("p", null, customerNumberLabel, " ", customerRes?.shopperid), customerUsernameLabel && /*#__PURE__*/_react.default.createElement("p", null, customerUsernameLabel, " ", infoResponse?.username), pinLabel && /*#__PURE__*/_react.default.createElement("p", null, pinLabel, ' ', /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: `${accountUrl}/security/login-info/edit`
  }, _patternLibraryUtils.tracking.create('view_pin_link', true, false)), viewPinLabel))), isPro && /*#__PURE__*/_react.default.createElement("p", null, rewardPointsLabel, " ", customerRes?.proshopper?.rewardPoints), vip && /*#__PURE__*/_react.default.createElement(_common.VipInfo, null, /*#__PURE__*/_react.default.createElement(_common.VipTitle, null, vipAccountExecLabel), /*#__PURE__*/_react.default.createElement("p", null, vip?.repname, /*#__PURE__*/_react.default.createElement("br", null), callLabel, ":", ' ', /*#__PURE__*/_react.default.createElement(_common.AccDDA, {
    href: `tel:${vip?.phone}`
  }, vip.phone), /*#__PURE__*/_react.default.createElement("br", null), emailLabel, ":", ' ', /*#__PURE__*/_react.default.createElement(_common.AccDDA, {
    href: `mailto:${vip?.email}`
  }, vip.email)))), menus?.map(({
    menuTitle,
    menuItems
  }, i) => {
    return /*#__PURE__*/_react.default.createElement(_common.AccountMenus, {
      key: i
    }, menuTitle && /*#__PURE__*/_react.default.createElement(_common.AccountSubSectionHeading, null, menuTitle), /*#__PURE__*/_react.default.createElement(_common.AccList, null, menuItems?.map(({
      title,
      href,
      _name
    }, j) => /*#__PURE__*/_react.default.createElement(_common.AccListItem, {
      key: j,
      "data-cy": "acc-list-item"
    }, /*#__PURE__*/_react.default.createElement(_common.AccDDA, (0, _extends2.default)({
      href: href
    }, _patternLibraryUtils.tracking.create(_name, true, false)), title)))));
  }), /*#__PURE__*/_react.default.createElement(_common.List, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_common.AccDDA, (0, _extends2.default)({
    href: `${ssoUrl}/logout?realm=idp`
  }, _patternLibraryUtils.tracking.create('log_out_link', true, false)), signOutLabel))), /*#__PURE__*/_react.default.createElement(_common.Stopper, {
    tabIndex: "0",
    onFocus: () => {
      closeTray(accountTrayRef);
    }
  })), /*#__PURE__*/_react.default.createElement(_common.Overlay, {
    onClick: () => {
      closeTray(accountTrayRef);
    }
  }));
}
Authed.propTypes = {
  customerNumberLabel: _propTypes.default.string,
  customerUsernameLabel: _propTypes.default.string,
  pinLabel: _propTypes.default.string,
  viewPinLabel: _propTypes.default.string,
  rewardPointsLabel: _propTypes.default.string,
  vipAccountExecLabel: _propTypes.default.string,
  callLabel: _propTypes.default.string,
  emailLabel: _propTypes.default.string,
  signOutLabel: _propTypes.default.string,
  ssoUrl: _propTypes.default.string,
  accountUrl: _propTypes.default.string,
  accountProductsUrl: _propTypes.default.string,
  closeTray: _propTypes.default.func,
  accountTrayRef: _propTypes.default.object,
  menus: _propTypes.default.arrayOf(_propTypes.default.shape({
    menuTitle: _propTypes.default.string,
    menuItmes: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      href: _propTypes.default.string
    }))
  })),
  customerRes: _propTypes.default.object,
  infoResponse: _propTypes.default.object,
  displayName: _propTypes.default.string
};